// @ts-ignore
import { get, SESSION_END_POINTS } from 'srs-middleware';
import { useEffect } from 'react';

/**
 * Keeps the session alive while the user is focused on the page and checks auth
 * when the user returns to the page
 * @param intervalMinutes - Delay between checking authentication state
 */
export function useFocusedSessionPolling(intervalMinutes = 10) {

  // Check authentication if user is focused on page
	useEffect(() => {
		const timer = setInterval(() => {
			if (document.hidden) {
				return;
			}

			(async () => {
				try {
					await get(SESSION_END_POINTS.Current);
				} catch (e) {}
			})();
		}, intervalMinutes * 60 * 1000);
		return () => {
			clearInterval(timer);
		};
	}, [intervalMinutes]);

	// Test session validity when user returns to the page
	useEffect(() => {
		const handler = () => {
			(async () => {
				try {
					await get(SESSION_END_POINTS.Current);
				} catch (e) {}
			})();
		};
		window.addEventListener('focus', handler);
		return () => {
			window.removeEventListener('focus', handler);
		};
	}, [intervalMinutes]);
}

